import Slider from "react-slick";
import { useState } from "react";
import { useEffect } from "react";
import "./index.css";
import UsersModal from "../UsersModal";
import { useDispatch } from "react-redux";
import { getOurLearnersWorkAt } from "../../redux/actions/learnerWorkAt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { images } from "../../pages/Profile/imagelinks";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import useWindowSize from "../../hooks/useWindowSize";
import { useLocation } from "react-router-dom";
import "../../pages/Pricing/pricingslider.css";
import { userPlacements } from "../../utils/userPlacementsData";

const OurLearnersWorkAt = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [usersData, setUsersData] = useState({
    data: userPlacements?.slice(0, 10),
  });
  const [imageArray, setImageArray] = useState([]);
  const { width } = useWindowSize();
  const { pathname } = useLocation();

  console.log(pathname);

  // useEffect(()=> {
  //     dispatch(getOurLearnersWorkAt((successObj)=> setUsersData((prev)=> ({...prev, data : successObj?.data}))))
  // }, [])

  useEffect(() => {
    function modifiedArray() {
      const newArray = images?.sort((a, b) => 0.5 - Math.random());
      setImageArray(newArray?.slice(0, 4));
    }
    modifiedArray();
  }, []);

  const truncatedText = (text, noOfChar) => {
    if (text.length <= noOfChar) {
      return text;
    } else {
      const res = text.slice(0, noOfChar) + "...";
      return res;
    }
  };

  const workAtsettings = {
    dots: false,
    slidesToShow:
      pathname === "/pricing"
        ? 5
        : pathname === "/onboarding/analysis" || pathname === "/onboarding"
        ? 6
        : 7,
    rows: 1,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    easing: "linear",
    cssEase: "linear",
    infinite: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3.5,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.1,
          infinite: true,
          dots: false,
          arrows: false,
          swipeToSlide: false,
        },
      },
    ],
  };

  return (
    <>
      <div
        className={`arrows w-full  ${
          pathname === "/pricing" && "pricing-scroll"
        }`}
      >
        <Slider {...workAtsettings}>
          {usersData &&
            usersData?.data.map((item, index) => (
              <div key={index}>
                <div
                  className={`mx-1 h-[9.5rem] min-w-[8.3rem] px-3 py-2 ${
                    pathname === "/" ||
                    pathname === "/onboarding/analysis" ||
                    pathname === "/onboarding"
                      ? "bg-[#2D4F71]"
                      : "bg-[#FFFFFF]"
                  }  my-1 flex flex-col items-center justify-start rounded-xl shadow-md`}
                >
                  {item?.user_details?.profile_image ? (
                    <div className="relative">
                      <div className="h-[50px] w-[50px]">
                        <img
                          src={item?.user_details?.profile_image}
                          alt="profile image"
                          height="40"
                          width="40"
                          className="object-fit h-full w-full rounded-full"
                        />
                      </div>
                      {item?.user_details?.linkedin_url ? (
                        <button
                          className="absolute top-8 left-8"
                          onClick={() => {
                            window.open(
                              item?.user_details?.linkedin_url,
                              "_blank",
                            );
                          }}
                        >
                          <div className="h-[20px] w-[20px]">
                            <img
                              src={
                                "https://img.learntube.ai/public-assets/Content_player/LinkdIn.png?updatedAt=1681563676400"
                              }
                              alt="linkedIn icon"
                              className="h-full w-full object-cover"
                            />
                          </div>
                        </button>
                      ) : null}
                    </div>
                  ) : (
                    <div className="relative">
                      <div className="h-[50px] w-[50px] rounded-full">
                        <FontAwesomeIcon
                          className="text-[50px] text-slate-600"
                          icon={faUserCircle}
                        />
                      </div>
                      {item?.user_details?.linkedin_url ? (
                        <button
                          className="absolute top-8 left-8"
                          onClick={() => {
                            window.open(
                              item?.user_details?.linkedin_url,
                              "_blank",
                            );
                          }}
                        >
                          <div className="h-[20px] w-[20px]">
                            <img
                              src={
                                "https://img.learntube.ai/public-assets/Content_player/LinkdIn.png?updatedAt=1681563676400"
                              }
                              alt="LinkedIn icon"
                              className="h-full w-full object-cover"
                            />
                          </div>
                        </button>
                      ) : null}
                    </div>
                  )}

                  <p className="w-full truncate pt-2 text-center text-sm font-semibold">
                    {item?.user_details?.name}
                  </p>
                  <p className="w-full truncate text-center text-xs font-medium leading-3">
                    {item?.job_designation}
                  </p>
                  <div className="mx-2 mt-2 flex items-center justify-start">
                    <div></div>
                    <div className="mr-1 h-[38px] w-[38px]">
                      <img
                        src={item?.company_details?.company_image?.url}
                        alt="company image"
                        className="h-full w-full object-cover"
                        style={{
                          backgroundImage: "",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "fill",
                        }}
                      />
                    </div>
                    <p className="truncate text-xs font-medium">
                      {item?.company_details?.company_name
                        ? width < 768
                          ? truncatedText(
                              item?.company_details?.company_name,
                              10,
                            )
                          : truncatedText(
                              item?.company_details?.company_name,
                              12,
                            )
                        : null}
                    </p>
                  </div>
                </div>
              </div>
            ))}
        </Slider>
      </div>
      <div className="my-1 flex items-center justify-center pt-2">
        <div
          className={`mr-3 flex ${
            pathname === "/onboarding" || pathname === "/onboarding/analysis"
              ? "hidden"
              : ""
          }`}
        >
          {imageArray?.map((e) => (
            <img
              src={e}
              className="-ml-1 h-6 w-6 rounded-full outline outline-white md:h-7 md:w-7"
              alt="images"
            />
          ))}
        </div>
        <button
          className="text-sm font-semibold underline md:text-xl"
          onClick={() => setIsModalOpen(true)}
        >
          View 1000s More
        </button>
      </div>
      {isModalOpen && (
        <UsersModal
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
          usersData={usersData}
        />
      )}
    </>
  );
};

export default OurLearnersWorkAt;
